import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";

/**
 *  Permissions derived from User Role Claims

 *  @fields  - permissionManager .                
 *     JTA: {
      hasJTACreate: undefined, 
    },  
    AMM: {
      hasAMMHod: undefined,
      hasAMMBsd: undefined,
      hasAMMfmops: undefined,
      hasAMMfmc: undefined,
    },  
    IRA: {
      hasIRAIRACreate: undefined,
      hasIRADelete: undefined,
      hasIRARead: undefined,
      hasIRAReview: undefined,
      hasIRAUpdate: undefined,
      hasIRAVerify: undefined,
      hasIRAViewAllIncidents: undefined,
      hasIRAViewReviewedIncidents: undefined,
      hasIRAViewVerifiedIncidents: undefined,
    }, 
 * @FEAS_Role_Claims New Claims to be added under claimTypes
 * @returns {List<boolean>} permissionsManager
 */
const usePermissionManager = () => {
  const user = useSelector((state) => state.user);

  // Add your Apps' Role Claim here to make easy reference.
  const [claimTypes] = useState({
    JTACreate: "jta.createticket",
    AMMHod: "amm.hod",
    AMMBsd: "amm.bsd",
    AMMfmops: "amm.fmops",
    AMMfmc: "amm.fmc",
    IRACreate: "ira.createincidents",
    IRADelete: "ira.deleteincidents",
    IRARead: "ira.readincidents",
    IRAReview: "ira.reviewincidents",
    IRAUpdate: "ira.updateincidents",
    IRAVerify: "ira.verifyincidents",
    IRAViewAllInc: "ira.viewallincidents",
    IRAViewReviewedInc: "ira.viewreviewedincidents",
    IRAViewVerifiedInc: "ira.viewverifiedincidents",
  });

  // Add desired permission for your application - To modify setter below
  const [permissionsManager, setPermissionManager] = useState({
    JTA: {
      hasJTACreate: undefined,
    },
    AMM: {
      hasAMMHod: undefined,
      hasAMMBsd: undefined,
      hasAMMfmops: undefined,
      hasAMMfmc: undefined,
    },
    IRA: {
      hasIRAIRACreate: undefined,
      hasIRADelete: undefined,
      hasIRARead: undefined,
      hasIRAReview: undefined,
      hasIRAUpdate: undefined,
      hasIRAVerify: undefined,
      hasIRAViewAllIncidents: undefined,
      hasIRAViewReviewedIncidents: undefined,
      hasIRAViewVerifiedIncidents: undefined,
    },
  });

  useEffect(() => {
    if (user.roleClaims != []) {
      // Edit here to add roleclaims/permissions for Application
      setPermissionManager({
        JTA: { hasJTACreate: user.roleClaims.includes(claimTypes.JTACreate) },
        AMM: {
          hasAMMHod: user.roleClaims.includes(claimTypes.AMMHod),
          hasAMMBsd: user.roleClaims.includes(claimTypes.AMMBsd),
          hasAMMfmops: user.roleClaims.includes(claimTypes.AMMfmops),
          hasAMMfmops: user.roleClaims.includes(claimTypes.AMMfmc),
        },
        IRA: {
          hasIRACreate: user.roleClaims.includes(claimTypes.IRACreate),
          hasIRADelete: user.roleClaims.includes(claimTypes.IRADelete),
          hasIRARead: user.roleClaims.includes(claimTypes.IRARead),
          hasIRAReview: user.roleClaims.includes(claimTypes.IRAReview),
          hasIRAUpdate: user.roleClaims.includes(claimTypes.IRAUpdate),
          hasIRAVerify: user.roleClaims.includes(claimTypes.IRAVerify),
          hasIRAViewAllIncidents: user.roleClaims.includes(
            claimTypes.IRAViewAllInc
          ),
          hasIRAViewReviewedIncidents: user.roleClaims.includes(
            claimTypes.IRAViewReviewedInc
          ),
          hasIRAViewVerifiedIncidents: user.roleClaims.includes(
            claimTypes.IRAViewVerifiedInc
          ),
        },
      });
    }
  }, [user.roleClaims]);

  /* #region  Permissions Checker - Do not modify unless you're a PRO  */
  const HasPermissions = () => {
    return GetPermissionsByAppCode();
  };
  const GetPermissionsByAppCode = (appCode) => {
    var boolVal = false;
    if (
      user.roleClaims == undefined ||
      user.roleClaims == null ||
      user.roleClaims == []
    ) {
      return false;
    }

    Object.keys(permissionsManager).map((app) => {
      if (app != null && app == (appCode ?? app)) {
        Object.keys(permissionsManager[app]).map((item) => {
          if (
            permissionsManager[app][item] != undefined &&
            permissionsManager[app][item] != false
          ) {
            boolVal = true;
          }
        });
      }
    });
    return boolVal;
  };

  /* #endregion */

  const HasAMMPermissions = () => {
    return GetPermissionsByAppCode("AMM");
  };
  const HasIRAPermissions = () => {
    return GetPermissionsByAppCode("IRA");
  };
  const HasJTAPermissions = () => {
    return GetPermissionsByAppCode("JTA");
  };

  return {
    permissionsManager,
    claimTypes,
    HasPermissions,
    HasAMMPermissions,
    HasIRAPermissions,
    HasJTAPermissions,
  };
};

export default usePermissionManager;
